module.exports = __webpack_public_path__ + "static/img/14000132.2bacf675.png";